import React, { useEffect, useState } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';

const NetflixTitle: React.FC = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [hintPosition, setHintPosition] = useState(0);
  const navigate = useNavigate();

  const handlePlaySound = () => {
    const audio = new Audio(netflixSound);
    audio.play().catch(error => console.error("Audio play error:", error));
    setIsClicked(true); // Starts animation after clicking
    setShowHint(false); // Hide hint when clicked
  };

  useEffect(() => {
    if (isClicked) {
      const timer = setTimeout(() => {
        navigate('/browse');
      }, 4000); // Navigate after the animation completes
      return () => clearTimeout(timer);
    }
  }, [isClicked, navigate]);

  useEffect(() => {
    // Show hint after 5 seconds if not clicked
    if (!isClicked) {
      const hintTimer = setTimeout(() => {
        setShowHint(true);
      }, 5000);
      return () => clearTimeout(hintTimer);
    }
  }, [isClicked]);

  useEffect(() => {
    // Change hint position every 3 seconds
    if (showHint && !isClicked) {
      const positionInterval = setInterval(() => {
        setHintPosition(prev => (prev + 1) % 4); // Cycle through 4 positions
      }, 3000);
      return () => clearInterval(positionInterval);
    }
  }, [showHint, isClicked]);

  const hintTexts = [
    "Click anywhere to enter",
    "Click to continue",
    "Click to explore",
    "Click to begin"
  ];

  return (
    <div className="netflix-container" onClick={handlePlaySound}>
      <h1 className={`netflix-logo ${isClicked ? 'animate' : ''}`}>
        MANTAVYA MAHAJAN
      </h1>
      {showHint && !isClicked && (
        <div className={`click-hint position-${hintPosition}`}>
          {hintTexts[hintPosition]}
        </div>
      )}
    </div>
  );
};

export default NetflixTitle;